<template>
  <div class="container-div">
    <!-- <img class="login-logo" src="@/assets/img/logo_login_top.png" alt="" />
    <h1>行于云上物联网平台</h1> -->
    <div class="custom-div">
      <h1 class="platform-title">史河科技售后监控平台</h1>
      <div class="row-div">
        <label class="row-div-child-start" @click="toggleLoginMethod('pwd')"
          >账号登录</label
        >
        <!-- <div class="column-line"></div> -->
        <!-- 暂无接口，故屏蔽「手机验证登录」 -->
        <!-- <label class="row-div-child-end" @click="toast('暂未开放')">手机验证登录</label> -->
        <label class="row-div-child-end"></label>
        <label class="row-div-child-end"></label>
      </div>
      <!-- <div class="row-line"></div> -->
      <div class="bottom-div">
        <div class="bottom-item" v-if="loginMethod === 'password'">
          <el-input
            class="bottom-item-input"
            type="text"
            id="username"
            v-model="username"
            placeholder="请输入用户名"
            maxlength="20"
          />
          <br />
          <el-input
            class="bottom-item-input"
            type="password"
            id="password"
            v-model="password"
            maxlength="20"
            @keyup.enter.native="login"
            placeholder="请输入密码"
          />
          <br />
        </div>
        <!-- 验证码登录 -->
        <!-- <div class='bottom-item' v-else>
            <input class='bottom-item' type="text" id="phoneNumber" v-model="phoneNumber" placeholder="请输入手机号" />
            <br />
            <div class="bottom-item-row">
                <input class="bottom-input" type="text" id="verificationCode" v-model="verificationCode" placeholder="请输入验证码" />
                <div class='sms-text' @click="sendVerificationCode">{{ text.getSms }}</div>
            </div>
            <br />
        </div> -->
        <div class="row-div-padding">
          <!--          <el-checkbox class="row-div-child-start-save" v-model="saveInfo">记住我</el-checkbox>-->
          <div class="row-div-child-end-forget" @click="toast('暂未开放')">
            忘记密码
          </div>
        </div>
      </div>
      <el-button class="login-btn" @click="login" :disabled="false"
        >立即登录</el-button
      >
    </div>
  </div>
</template>

<script>
import { saveUserInfo } from "@/common/js/userInfo";
import {
  localStorageClean,
  localStorageManage,
} from "@/common/localStorage/localStorageManage";
import { RSA } from "@/common/rsa/rsa.js";

export default {
  data() {
    return {
      localLoginInfo: {},
      loginMethod: "password",
      username: "",
      password: "",
      phoneNumber: "",
      verificationCode: "",
      text: {
        getSms: "获取验证码",
      },
      saveInfo: true,
      rsa: null,
    };
  },
  methods: {
    login() {
      if (this.loginMethod === "password") {
        if (this.username.length === 0) {
          this.$message.error("请输入用户名");
          return;
        }
        if (this.password.length === 0) {
          this.$message.error("请输入密码");
          return;
        }

        localStorageClean();
        this.$api.auth
          .login({
            data: {
              userName: this.username,
              //password: this.password,
              password: this.password,
            },
          })
          .then((response) => {
            const { token, userId, roleId, roleName, realName, userName } =
              response.data;
            localStorage.setItem(localStorageManage.token, token);
            saveUserInfo(
              JSON.stringify({
                token,
                userId,
                roleId,
                roleName,
                realName,
                userName: userName || this.username,
              })
            );
            this.$router.replace("/aftersaleOverview");
          });
      }
    },
    sendVerificationCode() {},
    toggleLoginMethod(type) {
      if (type === "pwd") {
        this.loginMethod = "password";
      }
    },
    toast(msg) {
      this.$message(msg);
    },
  },
  mounted() {
    this.rsa = new RSA();
  },
};
</script>

<style scoped lang="scss">
@import "./css/login.scss";

.platform-title {
  margin: 0 0 28px;
  padding: 0;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #e8f4ff;
  letter-spacing: 2px;
  text-shadow: 0 0 12px rgba(0, 212, 255, 0.35);
  line-height: 1.4;
}

::v-deep .bottom-item-input .el-input__inner {
  background: rgba(0, 40, 80, 0.55);
  border: 1px solid rgba(0, 212, 255, 0.4);
  color: #e8f4ff;

  &::placeholder {
    color: #5a8aad;
  }

  &:focus {
    border-color: #00d4ff;
  }
}
</style>
